import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { HEADERMENU_PATH } from '../../../../../../routes/RoutesURL';
import { RootState } from '../../../../../../store/rootReducer';
import { InvestorStatus } from '../../../../../login/utils/Status';
import { ONBOARDING_PATH } from '../../../Onbording';
import ConfirmationModal from './ConfirmationModal';

const TypeChangeModal: React.FC = () => {
    const navigate = useNavigate();

    const AIStatus = useSelector((state: RootState) => state.user.investor?.status?.accreditation);
    const KYCStatus = useSelector((state: RootState) => state.user.investor?.status?.kyc);

    const [open, setOpen] = useState(false);

    const onConfirm = () => {
        // Navigate with state
        navigate(`${HEADERMENU_PATH.onboarding}/${ONBOARDING_PATH.ACCREDITATION}`, {
            state: { isComingFromAccreditation: true },
        });
    };

    const onClickClose = () => {
        setOpen(false);
    };

    return (
        <div>
            {AIStatus !== InvestorStatus.AIApproved && KYCStatus !== InvestorStatus.KYCApproved && (
                <p className="text-[#26AE60] WorkSans-Semibold cursor-pointer" onClick={() => setOpen(true)}>
                    Change
                </p>
            )}

            <ConfirmationModal title="Confirmation" open={open} onOk={onConfirm} onCancel={onClickClose} centered />
        </div>
    );
};

export default TypeChangeModal;
